import { useEffect } from 'react';
import './player-game-news.styles.scss';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import GameNewsList from '@/components/SHARED/game-news/game-news-list.component';

const PlayerGameNews = ({
  gameData,
  gameMessages
}) => {

  useEffect(() => {
    if (!gameData?.gameName) return;
    changeDocumentTitle(`Game News | ${gameData.gameName}`);
    const pageTitle = document.getElementById('page-title');
    if (pageTitle) {
      pageTitle.innerText = 'Game News';
    }
  }, [gameData?.gameName])

  return (
    <div className='player-game-news-container'>
      <div className='player-game-news-content g-card'>
        <div className='card-title'>Game News</div>
        <div className='g-space-1'></div>
        <GameNewsList gameMessages={gameMessages} />
      </div>
    </div>
  )
}

export default PlayerGameNews
